export enum WindowType {
  Normal,
  NormalResizable,
  Utility,
  Notification,
  NotificationPicker,
  BlotterContextMenu,
  Dropdown,
}

export class NativeDesktopWindowOptions {
  public id: string;
  public type: WindowType;

  constructor(sourceString?: string) {
    if (sourceString != null) {
      this.parseSourceString(sourceString);
    }
  }

  protected parseSourceString(sourceString: string): void {
    let raw = JSON.parse(sourceString);
    Object.assign(this, raw);
  }

  public toString(): string {
    let copy = Object.assign({}, this);
    return JSON.stringify(copy);
  }

  public static withIdAndType(id: string, type: WindowType): NativeDesktopWindowOptions {
    let options = new NativeDesktopWindowOptions();
    options.id = id;
    options.type = type;
    return options;
  }
}
